import axios from "../../js/project-axios.js"

const search = (keyword, type, limit) => {
    return axios.get("/index/search", {
        params: {
            keyword,
            type,
            limit
        }
    });
};

const listIndexTime = (indexId, endTime, limit) => {
    return axios.get("/index/listIndexTime", {
        params: {
            indexId,
            endTime,
            limit
        }
    });
};

const listFundTime = (indexId, endTime, limit) => {
    return axios.get("/index/listFundTime", {
        params: {
            indexId,
            endTime,
            limit
        }
    });
};

export default {
    search,
    listIndexTime,
    listFundTime
};